import React, { useState } from "react";
import styled, { css } from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import VoyaVideo from "../../../../img/voya.mp4";
import VoyaImage1 from "../../../../img/voya-1.png";
import VoyaImage2 from "../../../../img/voya-2.png";

const VoyaProjectSection = styled(ProjectSection)`
  background: color(srgb 0.0021 0.362 0.3427);
`;

const Button = styled.button`
  margin: 0 auto var(--spacing-large);
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border: none;
  font-size: var(--font-size-text-small);
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const Modal = styled.div`
  ${(props) =>
    props.open &&
    css`
      background: #000000cc;
      top: 0;
      left: 0;
      position: fixed;
      height: 100%;
      width: 100%;
      z-index: 100000;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: var(--spacing-large);
    `}
`;

const Video = styled.video`
  width: 100%;
  max-width: 74rem;
  height: auto;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 24px;
  left: 24px;
  margin: 0;
  background-color: #333333;
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border: none;
  font-size: var(--font-size-text-small);
  cursor: pointer;
  &:hover,
  &:focus {
    color: #ff73df;
  }
`;

function Voya() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <VoyaProjectSection>
      <ProjectTitle title="Voya" tag="2026" />
      <ProjectSectionSkills>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="Xcode">
          <Icons type="xcode-small" />
        </Badge>
        <Badge small title="Agents & AI">
          <Icons type="ai-small" />
        </Badge>
      </ProjectSectionSkills>

      <ProjectDescription>
        This app was inspired by my spontaneous travels in Japan, living like a local and exploring by living. I wanted
        an app where I could take a snap and capture my path. Bon voya! It stayed a static concept until AI tooling
        made it realistic to explore and prototype.
      </ProjectDescription>

      <Button onClick={() => setModalOpen(true)}>Watch Preview</Button>

      {modalOpen ? (
        <Modal open>
          <CloseButton onClick={() => setModalOpen(false)}>Close</CloseButton>
          <Video controls>
            <source src={VoyaVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </Video>
        </Modal>
      ) : null}

      <ProjectHeroImage srcMobile1={VoyaImage1} srcMobile2={VoyaImage2} mobile thinBorder />
    </VoyaProjectSection>
  );
}

export default Voya;
